import gql from 'graphql-tag'
import {
	main as mainFragment,
	kasse as kasseFragment,
	hardware as hardwareFragment,
	general as generalFragment,
	external as externalFragment

} from './fragments'

const query = gql`
query getCashRegister($id: ID!) {
	cashAssist {
		getCashRegister(id: $id) {
			id
			mod_ver
			deviceType
			hardwareId
			isSynced
			parameters {
				isTSEStillLive
				installedPrinters
				foreignCurrency {
					euro {
						exchangeRate
            			exchangeRateIsUsed
            			exchangeDateRefresh
					}
				}
			}
			device {
				appManagerVersion
				deviceStatus
			}
			...cashRegisterMain
			...cashRegisterKasse
			...cashRegisterHardware
			...cashRegisterGeneral
			...cashRegisterExternal
		}
	}
}
${mainFragment}
${kasseFragment}
${hardwareFragment}
${generalFragment}
${externalFragment}`

export default query
